import ConsumerScan from './consumerScan.js';

export default ConsumerScan;
